
import React, { useEffect, useState } from 'react'
import { QualifioTeaserEntry } from '../helper/interfaces';
import { TeaserData } from './teaser'
import { getExternalLink } from '../helper/link';

export default function TeaserQualifio(data: TeaserData) {
  const teaser = data.teaser as QualifioTeaserEntry;
  const externalUrl = getExternalLink(teaser);
  const [qualifioId] = useState(teaser.providerId ?? (externalUrl && externalUrl.split("id=").length > 1 ? externalUrl.split("id=")[1] : ""))

  const scriptSrc = `(function(b,o,n,u,s){
    var a,t;a=b.createElement(u);
    a.async=1;a.src=s;t=b.getElementsByTagName(u)[0];
    t.parentNode.insertBefore(a,t);o[n]=o[n]||[]})
  (document,window,'_qual_async','script','//pressenetzde.qualifioapp.com/kit/qualp.2.min.js');
  _qual_async.push(['createIframe', 'qualifio_insert_place_${teaser.id}', 'pressenetzde.qualifioapp.com',
  '20', '${qualifioId}', '100%', '1200', '', '', '', 'max-width:810px;margin:0 auto;']);`

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = scriptSrc;
    document.body.appendChild(script);
  }, [scriptSrc]);

  return (
    <React.Fragment>
    <div className="qualifio">
    <div id={`qualifio_insert_place_${teaser.id}`} className="qualifio_iframe_wrapper" suppressHydrationWarning></div>
  </div>
  </React.Fragment>)
}